var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZengyaqibeng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols-light:water-pump",
    clipPath: "url(#clip0_22_2174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.78314 13.2339C7.46975 13.2339 6.35269 12.773 5.43196 11.8512C4.51123 10.9294 4.05087 9.81177 4.05087 8.49837C4.05087 7.18498 4.51177 6.06792 5.43359 5.14719C6.3554 4.22646 7.473 3.7661 8.78639 3.7661C10.0998 3.7661 11.2168 4.22701 12.1376 5.14882C13.0583 6.07063 13.5187 7.18823 13.5187 8.50162C13.5187 9.81502 13.0578 10.9321 12.1359 11.8528C11.2141 12.7735 10.0965 13.2339 8.78314 13.2339ZM15.6902 7.90613V7.28139H14.0825C13.9021 6.46898 13.5623 5.74729 13.0629 5.11632C12.5635 4.48644 11.9545 3.98951 11.2358 3.62555H15.6902V3H16.5026V7.90694L15.6902 7.90613ZM1.06689 13.9992V9.09387H1.8793V9.71861H3.48706C3.66687 10.531 4.00673 11.2527 4.50663 11.8837C5.00599 12.5141 5.61502 13.011 6.33373 13.3744H1.8793V14L1.06689 13.9992Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.23502 7.4999L8.76877 6.70374L9.31958 7.4999C9.60176 7.9126 9.78645 8.22483 9.87364 8.4366C9.9603 8.64783 10.0036 8.86176 10.0036 9.0784C10.0031 9.4207 9.88556 9.70937 9.65104 9.94443C9.41653 10.1795 9.12785 10.297 8.78502 10.297C8.44218 10.297 8.15351 10.1781 7.91899 9.94037C7.68393 9.70314 7.56641 9.41772 7.56641 9.08409C7.56641 8.85228 7.6073 8.63835 7.68908 8.44229C7.77086 8.24731 7.95284 7.93318 8.23502 7.4999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_2174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZengyaqibeng);
export default __webpack_public_path__ + "static/media/zengyaqibeng.d68cbe61fa6e9d081bf898ed7be32df0.svg";
export { ForwardRef as ReactComponent };